module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "查看进展"
    }
  }, [_c('div', {
    staticClass: "view_mian"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("申请人基本信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterName.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("申请人姓名：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.RequesterName.NodeValue))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterPhoneNum.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("申请人电话：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.RequesterPhoneNum.NodeValue))])])], 1), _vm._v(" "), (_vm.commitType == 2) ? _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterOrganisation.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("所在单位：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.RequesterOrganisation.NodeValue))])])], 1) : _vm._e(), _vm._v(" "), (_vm.commitType == 2) ? _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.PersonIdentification.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("个人身份证明：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, _vm._l((_vm.dataInfo.PersonIdentification.NodeValue), function(item) {
    return _c('div', {
      key: item.index,
      staticClass: "grid-content bg-purple-light info_con"
    }, [_c('div', {
      ref: 'indexImg_' + item.FileGuid,
      refInFor: true,
      attrs: {
        "id": 'indexImg_' + item.FileGuid
      }
    }, [_c('ul', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('span', [_vm._v(_vm._s(item.FileName))]), _c('a', {
      staticClass: "view_a",
      attrs: {
        "target": "_blank",
        "id": "test"
      },
      on: {
        "click": function($event) {
          return _vm.showImgFn(item.FileGuid)
        }
      }
    }, [_vm._v("查看"), _c('img', {
      attrs: {
        "xss": "removed",
        "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid
      }
    })])])]), _vm._v(" "), _c('a', {
      staticClass: "download_a",
      attrs: {
        "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid,
        "download": "个人身份证明",
        "title": "下载",
        "target": "_blank"
      }
    }, [_vm._v("\n                                下载\n                                ")])])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title_sty"
  }, [_vm._v("待撤文章信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.ArticleName.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("题目名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.ArticleName.NodeValue))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.Author.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("作者：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.Author.NodeValue))])])], 1), _vm._v(" "), (_vm.commitType == 2) ? _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.UnitIdentification.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("单位允许撤除证明：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dataInfo.UnitIdentification.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid,
      "download": "单位允许撤除证明",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                            ")])])])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.CheckReport.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("检测报告单：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dataInfo.CheckReport.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.CheckReport.NodeValue[0].FileGuid, 'pdf')
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid,
      "download": "检测报告单",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                            ")])])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.ArticleLocation.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("待撤文章位置：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dataInfo.ArticleLocation.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid,
      "download": "待撤文章位置",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                            ")])])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("申请提交时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.CreateTime))])])], 1), _vm._v(" "), (_vm.dataInfo.ifShenhe == true) ? _c('div', {
    staticClass: "shenhe_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("审核意见")]), _vm._v(" "), (_vm.dataInfo.ifShowReview == false) ? _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核状态：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.CheckStatusText))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核意见：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.Comment))])]), _vm._v(" "), (_vm.dataInfo.ifShowReviewTip == true) ? _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con",
    staticStyle: {
      "margin-left": "150px",
      "margin-top": "-10px",
      "color": "#8b94a7"
    }
  }, [_vm._v("\n                                （撤稿完成后系统会发送短信通知）\n                            ")])]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.UpdateTime))])])], 1), _vm._v(" "), (_vm.dataInfo.ifReCommit == true) ? _c('el-button', {
    staticClass: "reApply_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.reApply
    }
  }, [_vm._v("重新提交申请")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.ifZhixing == true) ? _c('div', {
    staticClass: "chegao_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("撤除结果")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("撤除结果：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.CheckStatusText))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("结果详情：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.ExecuteComment))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(_vm.dataInfo.CheckStatusText == '执行撤除成功') ? _c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("撤除时间：")]) : _c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.dataInfo.ExecuteUpdateTime))])])], 1), _vm._v(" "), (_vm.dataInfo.ifReCommit == true) ? _c('el-button', {
    staticClass: "reApply_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.reApply()
      }
    }
  }, [_vm._v("重新提交申请")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn_box"
  }, [_c('el-button', {
    staticClass: "backRecord_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backRecord
    }
  }, [_vm._v(_vm._s(_vm.BtnText))])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70c0115f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userPages/applyRecord/viewRecord.vue
// module id = 1192
// module chunks = 1